import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['typeSelect', 'fileSection', 'descriptionSection', 'fileInput', 'formatHint']
  static values = { fileTypes: Array, descriptionTypes: Array, acceptByType: Object, formatHints: Object }

  connect () {
    this.update()
  }

  update () {
    const type = this.typeSelectTarget.value

    this.fileSectionTarget.classList.toggle('hidden', !this.fileTypesValue.includes(type))
    this.descriptionSectionTarget.classList.toggle('hidden', !this.descriptionTypesValue.includes(type))

    if (this.hasFileInputTarget) {
      this.fileInputTarget.accept = this.acceptByTypeValue[type] || ''
    }

    if (this.hasFormatHintTarget) {
      this.formatHintTarget.textContent = this.formatHintsValue[type] || ''
    }
  }
}
